import {VehicleCatalogueData} from '../types/VehicleCatalogueLogic';

export const alphaCatalogueResponseMockReducedForPassangerCars: VehicleCatalogueData = [
  {
    property_name: 'car_style',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'CARSTYLE_HATCHBACK',
        const_key_old: null,
        labels: [{label: 'Hatchback', label_short: null, language: 'EN', seo_label: 'hatchback'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'CARSTYLE_ESTATE_CAR',
        const_key_old: null,
        labels: [{label: 'Estate car', label_short: null, language: 'EN', seo_label: 'estate'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'CARSTYLE_SUV_OFFROAD',
        const_key_old: null,
        labels: [
          {label: 'SUV / Off-road', label_short: null, language: 'EN', seo_label: 'suv-offroad'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'fuel_type',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'FUELTYPE_PETROL',
        const_key_old: null,
        labels: [{label: 'Petrol', label_short: null, language: 'EN', seo_label: 'petrol'}],
        parent: null,
        properties: [{name: 'fuel_unit', value: 'FUEL_UNIT_L100KM'}],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'FUELTYPE_DIESEL',
        const_key_old: null,
        labels: [{label: 'Diesel', label_short: null, language: 'EN', seo_label: 'diesel'}],
        parent: null,
        properties: [{name: 'fuel_unit', value: 'FUEL_UNIT_L100KM'}],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'FUELTYPE_ELECTRIC',
        const_key_old: null,
        labels: [{label: 'Electric', label_short: null, language: 'EN', seo_label: 'electric'}],
        parent: null,
        properties: [{name: 'fuel_unit', value: 'FUEL_UNIT_KWH100KM'}],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'drive',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'DRIVE_FRONT',
        const_key_old: null,
        labels: [{label: 'FWD', label_short: null, language: 'EN', seo_label: 'fwd'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'DRIVE_REAR',
        const_key_old: null,
        labels: [{label: 'RWD', label_short: null, language: 'EN', seo_label: 'rwd'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'DRIVE_4X4',
        const_key_old: null,
        labels: [{label: '4x4', label_short: null, language: 'EN', seo_label: 'drive-4x4'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'feature',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: ['FEATURE_CATEGORY_COMFORT_CONVENIENCE'],
        const_key: 'FEATURE_AC',
        const_key_old: null,
        labels: [
          {
            label: 'Air conditioning',
            label_short: 'AC',
            language: 'EN',
            seo_label: 'air-conditioning',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: ['FEATURE_CATEGORY_COMFORT_CONVENIENCE'],
        const_key: 'FEATURE_AC_MANUAL',
        const_key_old: 'AIRCONDITIONING_MANUAL',
        labels: [
          {
            label: 'Manual air conditioning',
            label_short: 'Manual AC',
            language: 'EN',
            seo_label: 'air-conditioning-manual',
          },
        ],
        parent: 'FEATURE_AC',
        properties: [],
        sort_priority: null,
      },
      {
        categories: ['FEATURE_CATEGORY_COMFORT_CONVENIENCE'],
        const_key: 'FEATURE_AC_AUTOMATIC',
        const_key_old: 'AIRCONDITIONING_AUTOMATIC',
        labels: [
          {
            label: 'Automatic air conditioning',
            label_short: 'Automatic AC',
            language: 'EN',
            seo_label: 'air-conditioning-automatic',
          },
        ],
        parent: 'FEATURE_AC',
        properties: [],
        sort_priority: 73,
      },
      {
        categories: ['FEATURE_CATEGORY_COMFORT_CONVENIENCE'],
        const_key: 'FEATURE_AC_1ZONE',
        const_key_old: null,
        labels: [
          {
            label: 'Automatic 1-zone air conditioning',
            label_short: 'Aut. 1-zone',
            language: 'EN',
            seo_label: 'air-conditioning-1-zone',
          },
        ],
        parent: 'FEATURE_AC_AUTOMATIC',
        properties: [],
        sort_priority: null,
      },
      {
        categories: ['FEATURE_CATEGORY_COMFORT_CONVENIENCE'],
        const_key: 'FEATURE_AC_MULTIZONE',
        const_key_old: 'AIRCONDITIONING_AUTOMATIC_MULTI_ZONE',
        labels: [
          {
            label: 'Automatic multi-zone air conditioning',
            label_short: 'Aut. multi-zone',
            language: 'EN',
            seo_label: 'air-conditioning-multizone',
          },
        ],
        parent: 'FEATURE_AC_AUTOMATIC',
        properties: [],
        sort_priority: 42,
      },
      {
        categories: ['FEATURE_CATEGORY_COMFORT_CONVENIENCE'],
        const_key: 'FEATURE_AC_2ZONE',
        const_key_old: 'AIRCONDITIONING_AUTOMATIC_2_ZONES',
        labels: [
          {
            label: 'Automatic 2-zones air conditioning',
            label_short: 'Aut. 2-zone',
            language: 'EN',
            seo_label: 'air-conditioning-2-zone',
          },
        ],
        parent: 'FEATURE_AC_MULTIZONE',
        properties: [],
        sort_priority: 65,
      },
      {
        categories: ['FEATURE_CATEGORY_COMFORT_CONVENIENCE'],
        const_key: 'FEATURE_AC_3ZONE',
        const_key_old: 'AIRCONDITIONING_AUTOMATIC_3_ZONES',
        labels: [
          {
            label: 'Automatic 3-zones air conditioning',
            label_short: 'Aut. 3-zone',
            language: 'EN',
            seo_label: 'air-conditioning-3-zone',
          },
        ],
        parent: 'FEATURE_AC_MULTIZONE',
        properties: [],
        sort_priority: null,
      },
      {
        categories: ['FEATURE_CATEGORY_COMFORT_CONVENIENCE'],
        const_key: 'FEATURE_AC_4ZONE',
        const_key_old: 'AIRCONDITIONING_AUTOMATIC_4_ZONES',
        labels: [
          {
            label: 'Automatic 4-zones air conditioning',
            label_short: 'Aut. -zone4',
            language: 'EN',
            seo_label: 'air-conditioning-4-zone',
          },
        ],
        parent: 'FEATURE_AC_MULTIZONE',
        properties: [],
        sort_priority: null,
      },
      {
        categories: ['FEATURE_CATEGORY_COMFORT_CONVENIENCE'],
        const_key: 'FEATURE_INDEPENDENT_AC',
        const_key_old: null,
        labels: [
          {
            label: 'Independent air conditioning',
            label_short: 'Independent AC',
            language: 'EN',
            seo_label: 'auxiliary-air-conditioning',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: ['FEATURE_CATEGORY_COMFORT_CONVENIENCE'],
        const_key: 'FEATURE_CRUISECONTROL_ADAPTIVE',
        const_key_old: 'CRUISECONTROL_ADAPTIVE',
        labels: [
          {
            label: 'Adaptive cruise control',
            label_short: 'Adaptive',
            language: 'EN',
            seo_label: 'cruise-control-adaptive',
          },
        ],
        parent: 'FEATURE_CRUISECONTROL',
        properties: [],
        sort_priority: 22,
      },
      {
        categories: ['FEATURE_CATEGORY_COMFORT_CONVENIENCE'],
        const_key: 'FEATURE_SUNROOF',
        const_key_old: 'SUNROOF',
        labels: [
          {
            label: 'Sunroof',
            label_short: 'Sunroof',
            language: 'EN',
            seo_label: 'sunroof',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: ['FEATURE_CATEGORY_COMFORT_CONVENIENCE'],
        const_key: 'FEATURE_SUNROOF_ELECTRIC',
        const_key_old: 'SUNROOF_ELECTRIC',
        labels: [
          {
            label: 'Electric sunroof',
            label_short: 'Electric',
            language: 'EN',
            seo_label: 'sunroof-powered',
          },
        ],
        parent: 'FEATURE_SUNROOF',
        properties: [],
        sort_priority: 44,
      },
    ],
  },
  {
    property_name: 'emission_standard',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'EMISSIONSTANDARD_WLTP',
        const_key_old: null,
        labels: [
          {label: 'WLTP', label_short: null, language: 'EN', seo_label: 'emission-standard-wltp'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'EMISSIONSTANDARD_NEDC',
        const_key_old: null,
        labels: [
          {label: 'NEDC', label_short: null, language: 'EN', seo_label: 'emission-standard--nedc'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'EMISSIONSTANDARD_UNKNOWN',
        const_key_old: null,
        labels: [
          {label: 'Uknnown', label_short: null, language: 'EN', seo_label: 'emission-standard-na'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'service_book_type',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'SERVICEBOOKTYPE_PAPER',
        const_key_old: null,
        labels: [
          {
            label: 'Paper',
            label_short: null,
            language: 'EN',
            seo_label: 'maintenance-record-paper',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'SERVICEBOOKTYPE_ELECTRONIC',
        const_key_old: null,
        labels: [
          {
            label: 'Electronic',
            label_short: null,
            language: 'EN',
            seo_label: 'maintenance-record-electronic',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'SERVICEBOOKTYPE_NONE',
        const_key_old: null,
        labels: [
          {label: 'None', label_short: null, language: 'EN', seo_label: 'maintenance-record-none'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'battery_ownership_type',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'BATTERYOWNERSHIPTYPE_INCLUDED',
        const_key_old: null,
        labels: [
          {label: 'Included', label_short: null, language: 'EN', seo_label: 'battery-included'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'BATTERYOWNERSHIPTYPE_LEASE',
        const_key_old: null,
        labels: [{label: 'Lease', label_short: null, language: 'EN', seo_label: 'battery-leased'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'BATTERYOWNERSHIPTYPE_WITHOUT_BATTERY',
        const_key_old: null,
        labels: [
          {label: 'Without battery', label_short: null, language: 'EN', seo_label: 'no-battery'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'battery_type',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'BATTERYTYPE_LI_POL',
        const_key_old: null,
        labels: [
          {
            label: 'Lithium polymer (Li-pol)',
            label_short: null,
            language: 'EN',
            seo_label: 'li-pol',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'BATTERYTYPE_LI_ION',
        const_key_old: null,
        labels: [
          {label: 'Lithium-ion (Li-ion)', label_short: null, language: 'EN', seo_label: 'li-ion'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'BATTERYTYPE_LI_FE_PO4',
        const_key_old: null,
        labels: [
          {
            label: 'Lithium iron phosphate (Li-FePO4)',
            label_short: null,
            language: 'EN',
            seo_label: 'li-fepo4',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'body_color',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'COLOR_WHITE',
        const_key_old: null,
        labels: [{label: 'White', label_short: null, language: 'EN', seo_label: 'white'}],
        parent: null,
        properties: [{name: 'color_code', value: '#FFFFFF'}],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'COLOR_BLACK',
        const_key_old: null,
        labels: [{label: 'Black', label_short: null, language: 'EN', seo_label: 'black'}],
        parent: null,
        properties: [{name: 'color_code', value: '#000000'}],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'COLOR_GREY',
        const_key_old: null,
        labels: [{label: 'Grey', label_short: null, language: 'EN', seo_label: 'grey'}],
        parent: null,
        properties: [{name: 'color_code', value: '#D8D8D8'}],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'carvago_feature',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'FEATURE_220V_SOCKET',
        const_key_old: null,
        labels: [],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'FEATURE_ABS',
        const_key_old: null,
        labels: [],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'FEATURE_ACCIDENT_VEHICLE',
        const_key_old: null,
        labels: [],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'charging_connector_type',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'CHARGINGCONNECTORTYPE_MENNEKES',
        const_key_old: null,
        labels: [
          {label: 'Mennekes (type 2)', label_short: null, language: 'EN', seo_label: 'mennekes'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'CHARGINGCONNECTORTYPE_CCS2',
        const_key_old: null,
        labels: [{label: 'CCS2', label_short: null, language: 'EN', seo_label: 'ccs2'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'CHARGINGCONNECTORTYPE_CHADEMO',
        const_key_old: null,
        labels: [{label: 'CHAdeMO', label_short: null, language: 'EN', seo_label: 'chademo'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'color_type',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'COLORSPECIFICATION_METALLIC',
        const_key_old: null,
        labels: [{label: 'Metallic', label_short: null, language: 'EN', seo_label: 'metallic'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'COLORSPECIFICATION_PEARL',
        const_key_old: null,
        labels: [{label: 'Pearl', label_short: null, language: 'EN', seo_label: 'pearl-paint'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'condition',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'CONDITION_NEW',
        const_key_old: null,
        labels: [{label: 'New', label_short: null, language: 'EN', seo_label: 'condition-new'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'CONDITION_USED',
        const_key_old: null,
        labels: [{label: 'Used', label_short: null, language: 'EN', seo_label: 'condition-used'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'CONDITION_DEMONSTRATION_CAR',
        const_key_old: null,
        labels: [
          {
            label: 'Demonstration car',
            label_short: null,
            language: 'EN',
            seo_label: 'demo-vehicle',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'cost',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'COST_ITEM_TITLE_LOGISTICS',
        const_key_old: null,
        labels: [{label: 'Logistics', label_short: null, language: 'EN', seo_label: null}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'COST_ITEM_TITLE_VEHICLE_CLEANING',
        const_key_old: null,
        labels: [
          {
            label: 'Vehicle cleaning (exterier + interior)',
            label_short: null,
            language: 'EN',
            seo_label: null,
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'COST_ITEM_TITLE_INTERIOR_CLEANING',
        const_key_old: null,
        labels: [
          {
            label: 'Interior cleaning - vacuum cleaner, dusting',
            label_short: null,
            language: 'EN',
            seo_label: null,
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {property_name: 'country', vehicle_type: 'VEHICLETYPE_PASSENGER_CAR', keys: []},
  {
    property_name: 'currency',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'CURRENCY_AMD',
        const_key_old: null,
        labels: [{label: 'Armenian Dram', label_short: null, language: 'EN', seo_label: null}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'CURRENCY_AZN',
        const_key_old: null,
        labels: [
          {label: 'Azerbaijanian Manat', label_short: null, language: 'EN', seo_label: null},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'CURRENCY_BAM',
        const_key_old: null,
        labels: [{label: 'Convertible Mark', label_short: null, language: 'EN', seo_label: null}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'door_count',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'DOORCOUNT_1',
        const_key_old: null,
        labels: [{label: '1', label_short: '1', language: 'EN', seo_label: 'doorcount-1'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'DOORCOUNT_2',
        const_key_old: null,
        labels: [{label: '2', label_short: '2', language: 'EN', seo_label: 'doorcount-2'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'DOORCOUNT_3',
        const_key_old: null,
        labels: [{label: '3', label_short: '3', language: 'EN', seo_label: 'doorcount-3'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'emission_class',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'EMISSIONCLASS_1',
        const_key_old: null,
        labels: [{label: 'Euro 1', label_short: null, language: 'EN', seo_label: 'euro-1'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'EMISSIONCLASS_2',
        const_key_old: null,
        labels: [{label: 'Euro 2', label_short: null, language: 'EN', seo_label: 'euro-2'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'EMISSIONCLASS_3',
        const_key_old: null,
        labels: [{label: 'Euro 3', label_short: null, language: 'EN', seo_label: 'euro-3'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'feature_category',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'FEATURE_CATEGORY_COMFORT_CONVENIENCE',
        const_key_old: null,
        labels: [
          {
            label: 'Comfort and Convenience',
            label_short: null,
            language: 'EN',
            seo_label: 'comfort-convenience',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'FEATURE_CATEGORY_AUDIO_COMMUNICATION',
        const_key_old: null,
        labels: [
          {
            label: 'Audio and Communication',
            label_short: null,
            language: 'EN',
            seo_label: 'audio-communication',
          },
        ],
        parent: 'FEATURE_CATEGORY_COMFORT_CONVENIENCE',
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'FEATURE_CATEGORY_SEATS',
        const_key_old: null,
        labels: [{label: 'Seats', label_short: null, language: 'EN', seo_label: 'seats'}],
        parent: 'FEATURE_CATEGORY_COMFORT_CONVENIENCE',
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'fuel_unit',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'FUEL_UNIT_L100KM',
        const_key_old: null,
        labels: [
          {label: 'l/100km', label_short: null, language: 'EN', seo_label: 'litres-per-100-km'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'FUEL_UNIT_KG100KM',
        const_key_old: null,
        labels: [
          {label: 'kg/100km', label_short: null, language: 'EN', seo_label: 'kgs-per-100-km'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'FUEL_UNIT_KWH100KM',
        const_key_old: null,
        labels: [
          {label: 'kWh/100km', label_short: null, language: 'EN', seo_label: 'kWh-per-100-km'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'hand_drive_type',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'HANDDRIVETYPE_LEFT',
        const_key_old: null,
        labels: [
          {
            label: 'Left-hand drive',
            label_short: null,
            language: 'EN',
            seo_label: 'left-hand-drive',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'HANDDRIVETYPE_RIGHT',
        const_key_old: null,
        labels: [
          {
            label: 'Right-hand drive',
            label_short: null,
            language: 'EN',
            seo_label: 'right-hand-drive',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'hybrid_type',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'HYBRIDTYPE_FULL',
        const_key_old: null,
        labels: [
          {label: 'Full hybrid', label_short: null, language: 'EN', seo_label: 'full-hybrid'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'HYBRIDTYPE_PHEV',
        const_key_old: null,
        labels: [
          {label: 'Plug-in hybrid', label_short: null, language: 'EN', seo_label: 'plug-in-hybrid'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'HYBRIDTYPE_MHEV',
        const_key_old: null,
        labels: [
          {label: 'Mild hybrid', label_short: null, language: 'EN', seo_label: 'mild-hybrid'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'interior_color',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'INTERIORCOLOR_BLACK',
        const_key_old: null,
        labels: [{label: 'Black', label_short: null, language: 'EN', seo_label: 'interior-black'}],
        parent: null,
        properties: [{name: 'color_code', value: '#000000'}],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'INTERIORCOLOR_GREY',
        const_key_old: null,
        labels: [{label: 'Grey', label_short: null, language: 'EN', seo_label: 'interior-grey'}],
        parent: null,
        properties: [{name: 'color_code', value: '#D8D8D8'}],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'INTERIORCOLOR_BEIGE',
        const_key_old: null,
        labels: [{label: 'Beige', label_short: null, language: 'EN', seo_label: 'interior-beige'}],
        parent: null,
        properties: [{name: 'color_code', value: '#F9E0BB'}],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'interior_material',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'INTERIORMATERIAL_CLOTH',
        const_key_old: null,
        labels: [{label: 'Cloth', label_short: null, language: 'EN', seo_label: 'fabric'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'INTERIORMATERIAL_VELOUR',
        const_key_old: null,
        labels: [{label: 'Velour', label_short: null, language: 'EN', seo_label: 'velour'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'INTERIORMATERIAL_ALCANTARA',
        const_key_old: null,
        labels: [{label: 'Alcantara', label_short: null, language: 'EN', seo_label: 'alcantara'}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'seller_type',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'SELLERTYPE_PRIVATE_SELLER',
        const_key_old: null,
        labels: [
          {label: 'Private seller', label_short: null, language: 'EN', seo_label: 'private-seller'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'SELLERTYPE_DEALERSHIP',
        const_key_old: null,
        labels: [
          {label: 'Dealership', label_short: null, language: 'EN', seo_label: 'used-car-dealer'},
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'SELLERTYPE_CERTIFIED_DEALERSHIP',
        const_key_old: null,
        labels: [
          {
            label: 'Certified dealership',
            label_short: null,
            language: 'EN',
            seo_label: 'certified-dealership',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'service_book_state',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'SERVICEBOOKSTATE_PARTIALLY_FILLED',
        const_key_old: null,
        labels: [
          {
            label: 'Partially filled',
            label_short: null,
            language: 'EN',
            seo_label: 'maintenance-record-partially-filled',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'SERVICEBOOKSTATE_FULLY_FILLED',
        const_key_old: null,
        labels: [
          {
            label: 'Fully filled',
            label_short: null,
            language: 'EN',
            seo_label: 'maintenance-record-full',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'SERVICEBOOKSTATE_UNFILLED',
        const_key_old: null,
        labels: [
          {
            label: 'Unfilled',
            label_short: null,
            language: 'EN',
            seo_label: 'maintenance-record-empty',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'tire_aspect_ratio',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'TIRE_ASPECT_RATIO_35',
        const_key_old: null,
        labels: [{label: '35', label_short: null, language: 'EN', seo_label: null}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'TIRE_ASPECT_RATIO_40',
        const_key_old: null,
        labels: [{label: '40', label_short: null, language: 'EN', seo_label: null}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'TIRE_ASPECT_RATIO_45',
        const_key_old: null,
        labels: [{label: '45', label_short: null, language: 'EN', seo_label: null}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'tire_make',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'TIRE_MAKE_BARUM',
        const_key_old: null,
        labels: [{label: 'Barum', label_short: null, language: 'EN', seo_label: null}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'TIRE_MAKE_BFGOODRICH',
        const_key_old: null,
        labels: [{label: 'BFGoodrich', label_short: null, language: 'EN', seo_label: null}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'TIRE_MAKE_BRIDGESTONE',
        const_key_old: null,
        labels: [{label: 'Bridgestone', label_short: null, language: 'EN', seo_label: null}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    property_name: 'tire_model',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
    keys: [
      {
        categories: [],
        const_key: 'TIRE_MAKE_BARUM-MODEL_BRAVURIS_3HM',
        const_key_old: null,
        labels: [{label: 'Bravuris 3HM', label_short: null, language: 'EN', seo_label: null}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'TIRE_MAKE_BARUM-MODEL_BRAVURIS_5HM',
        const_key_old: null,
        labels: [{label: 'Bravuris 5HM', label_short: null, language: 'EN', seo_label: null}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'TIRE_MAKE_BARUM-MODEL_POLARIS_5',
        const_key_old: null,
        labels: [{label: 'Polaris 5', label_short: null, language: 'EN', seo_label: null}],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
  },
  {
    keys: [
      {
        categories: [],
        const_key: 'TRANSMISSION_MANUAL',
        const_key_old: null,
        labels: [
          {
            label: 'Manual',
            label_short: null,
            language: 'EN',
            seo_label: 'transmission-manual',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'TRANSMISSION_AUTOMATIC',
        const_key_old: null,
        labels: [
          {
            label: 'Automatic',
            label_short: null,
            language: 'EN',
            seo_label: 'transmission-auto',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
      {
        categories: [],
        const_key: 'TRANSMISSION_SEMI_AUTOMATIC',
        const_key_old: null,
        labels: [
          {
            label: 'Semi-automatic',
            label_short: null,
            language: 'EN',
            seo_label: 'transmission-semi-auto',
          },
        ],
        parent: null,
        properties: [],
        sort_priority: null,
      },
    ],
    property_name: 'transmission',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
  },
];
